import { Component } from '@theme/component';

/**
 * @typedef {Object} TextTruncateRefs
 * @property {HTMLElement} toggle - The "read more" / "read less" toggle button
 */

/**
 * Toggles a text block between a word-truncated preview and its full
 * content. Both versions are rendered server-side (see snippets/text.liquid)
 * and shown/hidden via the `data-expanded` attribute, so no client-side
 * measurement is needed.
 *
 * @extends {Component<TextTruncateRefs>}
 */
class TextTruncateComponent extends Component {
  requiredRefs = ['toggle'];

  /**
   * Toggles the expanded state of the text block.
   */
  toggle = () => {
    const expanded = this.getAttribute('data-expanded') === 'true';

    this.setAttribute('data-expanded', expanded ? 'false' : 'true');
    this.refs.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  };
}

if (!customElements.get('text-truncate-component')) {
  customElements.define('text-truncate-component', TextTruncateComponent);
}
